module.exports = __webpack_public_path__ + "static/media/daily_menu_availability.cc764883.svg";